import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { bidsAdapter, myBidsApiSlice as api } from 'services/api/my-bids';
import { SocketMessage } from 'services/api/types';
import getSocket from '.';
import { WS_FIRST_BID, WS_ROS_ACTIVE_CHANGED, WS_ROS_VERSION_GENERATED } from 'constants/actionTypes';
import uploadVehicleApi from 'services/api/upload-vehicle';

export const useBuyerGlobalSocketHandler = () => {
  const user = useSelector((state: any) => state.user?.user);
  const dispatch = useDispatch() as ThunkDispatch<any, any, AnyAction>;
  const { page, perPage, filters } = useSelector((state: any) => state.myBids);

  const paginationRef = useRef({ page, perPage, filters });
  paginationRef.current = { page, perPage, filters };

  const listener = ({ type, payload }: SocketMessage) => {
    if (type === WS_FIRST_BID) {
      dispatch(api.util.invalidateTags(['MyBids', 'MyBidsCounters']));
    }

    if (type === WS_ROS_VERSION_GENERATED && payload.report_type === 'buyer') {
      const vehicleId: number = payload.vehicle_id;

      dispatch(
        uploadVehicleApi.util.updateQueryData('getVehicleById', vehicleId, draft => {
          (draft as any).buyer_report_of_sale = payload.url;
        })
      );

      const { page: p, perPage: pp, filters: f } = paginationRef.current;
      dispatch(
        api.util.updateQueryData('getMyBids', { limit: pp, offset: p, ...f }, draft => {
          bidsAdapter.updateOne(draft.rows, {
            id: vehicleId,
            changes: { buyer_report_of_sale: payload.url }
          });
        })
      );
    }

    if (type === WS_ROS_ACTIVE_CHANGED && payload.report_type === 'buyer') {
      const vehicleId: number = payload.vehicle_id;

      dispatch(
        uploadVehicleApi.util.updateQueryData('getVehicleById', vehicleId, draft => {
          (draft as any).buyer_report_of_sale = payload.url;
        })
      );

      const { page: p, perPage: pp, filters: f } = paginationRef.current;
      dispatch(
        api.util.updateQueryData('getMyBids', { limit: pp, offset: p, ...f }, draft => {
          bidsAdapter.updateOne(draft.rows, {
            id: vehicleId,
            changes: { buyer_report_of_sale: payload.url }
          });
        })
      );
    }
  };

  useEffect(() => {
    if (!user || user.role !== 'buyer') return;

    const socket = getSocket();
    socket.emit('subscribe', { prefix: `user`, ids: [user.id] });
    socket.on('message', listener);

    return () => {
      socket.emit('unsubscribe', { prefix: `user`, ids: [user.id] });
      socket.off('message', listener);
    };
  }, [dispatch, user?.id, user?.role]);
};
